import type { OrganizationStatus } from "../types/organization.types";

const statusLabels: Record<OrganizationStatus, string> = {
	active: "Faol",
	disabled: "To'xtatilgan",
};

const statusClassNames: Record<OrganizationStatus, string> = {
	active: "green",
	disabled: "red",
};

interface OrganizationStatusBadgeProps {
	status: OrganizationStatus;
}

export function OrganizationStatusBadge({ status }: OrganizationStatusBadgeProps) {
	return (
		<span className={`crm-status-badge ${statusClassNames[status]}`}>
			<span />
			{statusLabels[status]}
		</span>
	);
}
